import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../../services/wrapper-http-service';
import { ListServerPaginationStateModel, getQueryStringFromObject } from '../../../../../../../common';
import { API_URL } from '../../../../../../../services/config';
import { UliEndpoint } from '../../constants/uli-endpoint';
import { UliItemTruck, UliItemTruckListSearchCriteria, UliItemActionParams } from '../../models';
import { RequestHeader } from '../../../../../../constants/headers';

@Injectable({
  providedIn: 'root',
})
export class UliItemTruckService {
  constructor(private http: WrapperHttpService) {}

  getUliTruckList(
    { uli, type, compartmentId }: UliItemActionParams,
    searchCriteria: UliItemTruckListSearchCriteria,
    hubId: number,
  ): Observable<ListServerPaginationStateModel<UliItemTruck>> {
    const url = `${API_URL}${UliEndpoint.Uli}/${uli}${UliEndpoint.Assign}${
      UliEndpoint.Trucks
    }?${getQueryStringFromObject({
      compartmentId,
      type,
      ...searchCriteria,
    })}`;
    const headers = new HttpHeaders({ [RequestHeader.IntrackHubId]: hubId.toString() });

    return this.http.withLoading().get<ListServerPaginationStateModel<UliItemTruck>>(url, { headers });
  }

  // TODO: check where we use this endpoint
  assignTruck({
    params: { uli, compartmentId, type },
    truckId,
  }: {
    params: UliItemActionParams;
    truckId: number;
  }): Observable<void> {
    const url = `${API_URL}${UliEndpoint.Uli}/${uli}${UliEndpoint.Assign}?${getQueryStringFromObject({
      compartmentId,
      truckId,
      type,
    })}`;
    return this.http.withLoading().post<void>(url, {});
  }
}
